import { render, staticRenderFns } from "./busWitnessTable.vue?vue&type=template&id=32981d7f&scoped=true"
import script from "./busWitnessTable.vue?vue&type=script&lang=js"
export * from "./busWitnessTable.vue?vue&type=script&lang=js"
import style0 from "./busWitnessTable.vue?vue&type=style&index=0&id=32981d7f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32981d7f",
  null
  
)

export default component.exports